// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: linear-gradient(90deg, #B37A56 0%, #FBCBA7 32.29%, #C38A79 71.35%, #945B3B 95.31%);
  --secondary-color: #111827;
  --button-color: #074870;
  --light-color: #fff;
  --dark-color: #000;
  --text-color: #94A3B8;
  --card-color: #002942;
}

body {
  margin: 0px;
  padding: 0px;
  line-height: 1.7;
  font-weight: 400;
  background-color: var(--secondary-color) !important;
  font-family: "Rubik", sans-serif;
}

* {
  letter-spacing: 0.5px;
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: "Rubik", sans-serif;
}

ol,
li,
a,
ul,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  padding: 0px;
  font-family: "Rubik", sans-serif;
}

.main_wrap {
  min-height: calc(100vh - 265px);
  margin: 50px 0px;
}
.main_wrap .bridge_wrap {
  width: 100%;
  max-width: 550px;
  margin: 0px auto;
  background-color: var(--card-color);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 8px -4px rgba(20, 23, 26, 0.1215686275), 0 4px 16px -1px rgba(20, 23, 26, 0.0784313725);
}
.main_wrap .bridge_wrap ul {
  padding: 0px;
  display: flex;
  background: var(--secondary-color);
  justify-content: space-between;
  gap: 5px;
  border-radius: 10px;
}
.main_wrap .bridge_wrap ul li {
  list-style: none;
  width: 100%;
  text-align: center;
  border-radius: 12px;
}
.main_wrap .bridge_wrap ul li a {
  text-align: center;
  width: 100%;
  border-radius: 8px;
  padding: 8px;
  text-decoration: none;
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  color: var(--text-color);
  position: relative;
  transition: all 0.5s ease;
}
.main_wrap .bridge_wrap ul li a:hover {
  background-color: rgba(7, 72, 112, 0.2196078431);
}
.main_wrap .bridge_wrap ul li a.active {
  box-shadow: 0 0 8px rgba(20, 23, 26, 0.0784313725), 0 0 4px rgba(20, 23, 26, 0.0392156863);
  color: #FBCBA7;
  background-color: var(--button-color);
}
.main_wrap .bridge_wrap ul li a.active::after {
  position: absolute;
  height: 3px;
  left: 50%;
  bottom: 0px;
  content: "";
  width: 20%;
  background: var(--primary-color);
  transform: translate(-50%);
  border-radius: 3px 3px 0px 0px;
}

.pagination_wrap .pagination {
  margin: 0px;
  justify-content: start !important;
}
.pagination_wrap .pagination .page-item.active .page-link {
  border: 1px solid #FBCBA7;
  border-radius: 5px;
  padding: 0px 11px;
}
.pagination_wrap .pagination .page-item .page-link {
  background: var(--secondary-color);
  color: #FBCBA7;
  border-color: var(--secondary-color);
  padding: 1px 10px;
  font-size: 12px;
}
.pagination_wrap .pagination .page-item .page-link:focus {
  box-shadow: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

::placeholder {
  /* Most modern browsers support this now. */
  color: var(--text-color) !important;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  left: 50%;
  transform: translate(-50%);
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/common/_color_variable.scss","webpack://./src/assets/style/main.scss"],"names":[],"mappings":"AAAA;EAEI,mGAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;ACCJ;;AANA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mDAAA;EACA,gCAAA;AASJ;;AANA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;AASJ;;AANA;;;;;;;;;;;EAWI,WAAA;EACA,YAAA;EACA,gCAAA;AASJ;;AALA;EACI,+BAAA;EACA,gBAAA;AAQJ;AANI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uGAAA;AAQR;AANQ;EACI,YAAA;EACA,aAAA;EACA,kCAAA;EACA,8BAAA;EACA,QAAA;EACA,mBAAA;AAQZ;AANY;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAQhB;AANgB;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;AAQpB;AANoB;EACI,gDAAA;AAQxB;AALoB;EACI,0FAAA;EACA,cAAA;EACA,qCAAA;AAOxB;AALwB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,0BAAA;EACA,8BAAA;AAO5B;;AAKI;EACI,WAAA;EACA,iCAAA;AAFR;AAMgB;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;AAJpB;AAQY;EACI,kCAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;AANhB;AAQgB;EACI,gBAAA;AANpB;;AAaA,gCAAA;AACA;;EAEI,wBAAA;EACA,SAAA;AAVJ;;AAaA,YAAA;AACA;EACI,0BAAA;AAVJ;;AAwCA;EACI,2CAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AAVJ;;AAaA;EACI,SAAA;EACA,sCAAA;AAVJ;;AAaA;EACI,SAAA;EACA,sCAAA;AAVJ;;AAaA;EACI,UAAA;EACA,sCAAA;AAVJ;;AAaA;EACI,UAAA;EACA,sCAAA;AAVJ;;AAaA;EACI;IACI,mBAAA;EAVN;EAaE;IACI,mBAAA;EAXN;AACF;AAcA;EACI;IACI,mBAAA;EAZN;EAeE;IACI,mBAAA;EAbN;AACF;AAgBA;EACI;IACI,0BAAA;EAdN;EAiBE;IACI,6BAAA;EAfN;AACF","sourcesContent":[":root {\r\n    // --primary-color: #EDE4C5;\r\n    --primary-color: linear-gradient(90deg, #B37A56 0%, #FBCBA7 32.29%, #C38A79 71.35%, #945B3B 95.31%);\r\n    --secondary-color: #111827;\r\n    --button-color: #074870;\r\n    --light-color: #fff;\r\n    --dark-color: #000;\r\n    --text-color: #94A3B8;\r\n    --card-color: #002942;\r\n}","@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800;900&display=swap');\n@import \"./common/color_variable\";\n\nbody {\n    margin: 0px;\n    padding: 0px;\n    line-height: 1.7;\n    font-weight: 400;\n    background-color: var(--secondary-color) !important;\n    font-family: 'Rubik', sans-serif;\n}\n\n* {\n    letter-spacing: 0.5px;\n    margin: 0px;\n    padding: 0px;\n    box-sizing: border-box;\n    font-family: 'Rubik', sans-serif;\n}\n\nol,\nli,\na,\nul,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n    margin: 0px;\n    padding: 0px;\n    font-family: 'Rubik', sans-serif;\n}\n\n\n.main_wrap {\n    min-height: calc(100vh - 265px);\n    margin: 50px 0px;\n\n    .bridge_wrap {\n        width: 100%;\n        max-width: 550px;\n        margin: 0px auto;\n        background-color: var(--card-color);\n        padding: 20px;\n        border-radius: 12px;\n        box-shadow: 0 0 8px -4px #14171a1f, 0 4px 16px -1px #14171a14;\n\n        ul {\n            padding: 0px;\n            display: flex;\n            background: var(--secondary-color);\n            justify-content: space-between;\n            gap: 5px;\n            border-radius: 10px;\n\n            li {\n                list-style: none;\n                width: 100%;\n                text-align: center;\n                border-radius: 12px;\n\n                a {\n                    text-align: center;\n                    width: 100%;\n                    border-radius: 8px;\n                    padding: 8px;\n                    text-decoration: none;\n                    display: inline-block;\n                    font-weight: 500;\n                    font-size: 14px;\n                    color: var(--text-color);\n                    position: relative;\n                    transition: all 0.5s ease;\n\n                    &:hover {\n                        background-color: #07487038;\n                    }\n\n                    &.active {\n                        box-shadow: 0 0 8px rgba(20, 23, 26, 0.0784313725), 0 0 4px rgba(20, 23, 26, 0.0392156863);\n                        color: #FBCBA7;\n                        background-color: var(--button-color);\n\n                        &::after {\n                            position: absolute;\n                            height: 3px;\n                            left: 50%;\n                            bottom: 0px;\n                            content: \"\";\n                            width: 20%;\n                            background: var(--primary-color);\n                            transform: translate(-50%);\n                            border-radius: 3px 3px 0px 0px;\n                        }\n                    }\n\n                }\n            }\n        }\n    }\n\n}\n\n.pagination_wrap {\n    .pagination {\n        margin: 0px;\n        justify-content: start !important;\n\n        .page-item {\n            &.active {\n                .page-link {\n                    border: 1px solid #FBCBA7;\n                    border-radius: 5px;\n                    padding: 0px 11px;\n                }\n            }\n\n            .page-link {\n                background: var(--secondary-color);\n                color: #FBCBA7;\n                border-color: var(--secondary-color);\n                padding: 1px 10px;\n                font-size: 12px;\n\n                &:focus {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\n::-webkit-input-placeholder {\n    /* WebKit, Blink, Edge */\n    color: var(--text-color) !important;\n}\n\n:-moz-placeholder {\n    /* Mozilla Firefox 4 to 18 */\n    color: var(--text-color) !important;\n    opacity: 1;\n}\n\n::-moz-placeholder {\n    /* Mozilla Firefox 19+ */\n    color: var(--text-color) !important;\n    opacity: 1;\n}\n\n:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: var(--text-color) !important;\n}\n\n::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: var(--text-color) !important;\n}\n\n::placeholder {\n    /* Most modern browsers support this now. */\n    color: var(--text-color) !important;\n}\n\n.lds-ellipsis {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n    left: 50%;\n    transform: translate(-50%);\n}\n\n.lds-ellipsis div {\n    position: absolute;\n    top: 33px;\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    background: #fff;\n    animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n\n.lds-ellipsis div:nth-child(1) {\n    left: 8px;\n    animation: lds-ellipsis1 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(2) {\n    left: 8px;\n    animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(3) {\n    left: 32px;\n    animation: lds-ellipsis2 0.6s infinite;\n}\n\n.lds-ellipsis div:nth-child(4) {\n    left: 56px;\n    animation: lds-ellipsis3 0.6s infinite;\n}\n\n@keyframes lds-ellipsis1 {\n    0% {\n        transform: scale(0);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes lds-ellipsis3 {\n    0% {\n        transform: scale(1);\n    }\n\n    100% {\n        transform: scale(0);\n    }\n}\n\n@keyframes lds-ellipsis2 {\n    0% {\n        transform: translate(0, 0);\n    }\n\n    100% {\n        transform: translate(24px, 0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
